export default {
    newPageCreateFile: "ファイルを作成しています",
    globalConfirm: "OK",
    globalCancel: "キャンセル",
    globalStyle: "スタイル",
    globalColor: "テーマ色",
    globalLine: "線",
};
